<ng-template hisDynamicFieldHost></ng-template>

@if (hisBaseGlobalsService.dataDictionaryEditMode()) {
  <span>
    <a href={{getLinkToPageRulesetEditor()}}>Link zum Ruleset-Editor</a>
  </span>
}